import React from "react";
import { Link } from "react-router-dom";

// COMPONENTS
import Icon from "../icons/Icon";
import Layout from "../layout/Layout";
import Title from "../text/Title";

const MainNav = ({ title, titleTag, data, activeItem, clicked, linkTo }) => {
  const handleLinkClick = () => {
    if (clicked) clicked();
  };

  return (
    <nav className="__k" role="navigation" data-test="MainNav" aria-labelledby="mainNavLabel">
      {title && (
        <Title id="mainNavLabel" tagName={titleTag}>
          {title}
        </Title>
      )}

      <ul data-test="MainNavList">
        {data &&
          data.map(item => {
            return (
              <li key={item.id} data-test="MainNavListItem">
                <a
                  onClick={handleLinkClick}
                  className={`__k_i ${activeItem === item.id ? "bc1 c10" : "c16"}`}
                  href={`${linkTo}/${item.id}`}
                  aria-label={item.title}
                  data-test="MainNavListAnchor"
                  aria-current={activeItem === item.id ? "location" : false}
                >
                  <Layout flex spaceBetween lastItemRight>
                    <Icon
                      iconId="checkLine"
                      addClass={`ic-ch ${activeItem !== item.id ? "c1" : ""} ${
                        item.confirmed ? "" : "__h-ho"
                      }`}
                    />
                    <div data-test="MainNavItemText">{`${
                      item.shortcode ? item.shortcode + " - " : ""
                    }${item.title}`}</div>
                    {item.stats ? (
                      <div className="__k_s" data-test="MainNavItemTextStats">
                        {item.stats.done}/{item.stats.total}
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </Layout>
                </a>
              </li>
            );
          })}
      </ul>
    </nav>
  );
};

export default MainNav;
